export const About = () => {
	return (
		<div className="flex flex-col h-full p-6 max-w-lg mx-auto">
			<h1 className="text-xl font-semibold text-white mb-6">About</h1>

			<div className="glass-panel rounded-2xl p-6 space-y-4">
				<div>
					<h2 className="text-base font-medium text-white mb-1">Cheogram</h2>
					<p className="text-sm text-white/60">A modern XMPP client built with React and Tailwind.</p>
				</div>

				<div className="border-t border-white/8 pt-4">
					<p className="text-xs text-white/40">AGPL-3.0 License</p>
					<a
						href="https://cheogram.com"
						className="text-xs text-primary-light hover:underline mt-1 block"
					>
						cheogram.com
					</a>
				</div>
			</div>
		</div>
	);
};
